import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const account: RouteRecordRaw[] = [
  {
    ...SETTINGS.account.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.account-title",
    },
    component: () => import("@/Views/settings/account/index.vue"),
  },
  {
    ...SETTINGS.account.username.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.username.change_name_and_surname-title",
    },
    component: () => import("@/Views/settings/account/username/Username.vue"),
  },
  {
    ...SETTINGS.account.password.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.password",
    },
    component: () => import("@/Views/settings/account/password/Password.vue"),
  },
  {
    ...SETTINGS.account.email.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.email",
    },
    component: () => import("@/Views/settings/account/email/Email.vue"),
  },
  {
    ...SETTINGS.account.description.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.change_description",
    },
    component: () => import("@/Views/settings/account/description/Description.vue"),
  },
  {
    ...SETTINGS.account.iban.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.iban",
    },
    component: () => import("@/Views/settings/account/iban/Iban.vue"),
  },
  {
    ...SETTINGS.account.delete.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.delete_account",
    },
    component: () => import("@/Views/settings/account/delete/index.vue"),
  },
  {
    ...SETTINGS.account.delete.reason.root,
    meta: {
      sidebar: false,
      i18nTitle: "account.delete_account",
    },
    component: () => import("@/Views/settings/account/delete/DeleteReason.vue"),
  },
];

export default account;
